import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

type ExportRow = Record<string, unknown>;

export const generateCSV = (data: ExportRow[] = [], fileName: string, headers: string[] = []) => {
    const normalizedRows =
        data.length === 0 && headers.length > 0 ? [Object.fromEntries(headers.map((header) => [header, '']))] : data;
    const ws = XLSX.utils.json_to_sheet(normalizedRows, headers.length > 0 ? { header: headers } : undefined);
    if (data.length === 0 && headers.length > 0) {
        ws['!ref'] = XLSX.utils.encode_range({
            s: { c: 0, r: 0 },
            e: { c: headers.length - 1, r: 0 },
        });
    }
    const csv = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

    saveAs(blob, fileName);
};
